import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getOrdTypes = async () => {
  return await request.get(
    `/Docs/ord_types`,
    null,
    'При загрузке типов документа произошла ошибка'
  );
};

const useDocsOrdTypesQuery = (options) =>
  useQuery(queryKeys.ordTypes(), () => getOrdTypes(), options);

export default useDocsOrdTypesQuery;
